import React from 'react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ValidationCounterfactualPage from "./pages/ValidationCounterfactualPage"
import ValidationNamesGendersPage from "./pages/ValidationNamesGendersPage"

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
    },
    typography: {
        fontFamily: 'Roboto, sans-serif',
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/counterfactual-validation" element={<ValidationCounterfactualPage />} />
                    <Route path="/name-gender-validation" element={<ValidationNamesGendersPage />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
}

export default App;
